import { api } from '@/services'
import { useState } from 'react'
import { useIsomorphicLayoutEffect } from '@/hooks/Custom'

const useClientAddress = (clientId: string) => {
    const [Response, setResponse] = useState(null)
    const [Error, setError] = useState(null)
    const [Loading, setLoading] = useState(true)

    useIsomorphicLayoutEffect(() => {
        const Controller = new AbortController()

        const MakeRequest = async () => {
            try {
                const resp = await api.get(
                    `/Client/GetAddressByClient_id?id=${clientId}`,
                    {
                        signal: Controller.signal
                    }
                )
                setResponse(resp.data)
            } catch (error) {
                setError(error)
            } finally {
                setLoading(false)
            }
        }

        MakeRequest()

        return () => Controller.abort()
    }, [])

    return [Response, Error, Loading]
}

export { useClientAddress }
